import { useState, useEffect } from "react"
import { PieChart } from '@mui/x-charts/PieChart';
import { useUser } from "../../utils/UserContext";
import { getCurrencySymbol, formatCurrency, getRate } from '../../utils/currencyUtils';

function Pie({crypto, fiat, stock}) {
    const { user } = useUser();
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
    }, [currencyCode]);

    const valueFormatter = (item) => `${getCurrencySymbol(user?.currency)}${formatCurrency(item.value * rate)} ${user?.currency}`;
    const desktopOS = [
      {
        label: `Crypto - ${getCurrencySymbol(user?.currency)}${formatCurrency(crypto * rate)}`,
        value: parseFloat(crypto),
      },
      {
        label: `Fiat - ${getCurrencySymbol(user?.currency)}${formatCurrency(fiat * rate)}`,
        value: parseFloat(fiat),
      },
      {
        label: `Stock - ${getCurrencySymbol(user?.currency)}${formatCurrency(stock * rate)}`,
        value: parseFloat(stock),
      },
    ];

    return (
        <PieChart
            series={[
                {
                data: desktopOS,
                highlightScope: { fade: 'global', highlight: 'item' },
                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                valueFormatter,
                innerRadius: 30,
                outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                borderWidth: 0,
                },
            ]}
            height={200}
            width={200}
        />
    )
}

export default Pie